import { render } from "./FootView.vue?vue&type=template&id=0a6a8924&scoped=true"
const script = {}

import "./FootView.vue?vue&type=style&index=0&id=0a6a8924&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6a8924"]])

export default __exports__